<!-- eslint-disable -->
<template>
  <span style="display: inline-flex">
    <span class="item-name-loading">
      {{C_calculatedNameLabel}}
      <clip-loader v-if="showLoading === true" :loading="DV_isLoading" :color="'black'" :size="'15px'"></clip-loader>
    </span>   
  </span>
</template>

<script>
import ClipLoader from 'vue-spinner/src/ClipLoader.vue'

/* eslint-disable */
export default {
  name: "c13ObjectAttributeNameLabel",
  components: {ClipLoader},
  props: ["showLoading", "objectAttributeUid", "isNameNeeded"],
  data() {
    return {
      objectAttributeMetaData: {},
      isInitiailized: false,
      DV_isLoading: true
    };
  },
  mounted: function() {
      this.$nextTick(function(){
      this.startListener();
      });
  },
  methods: {
    startListener() {
      //we have to make sure the firebase DB is actually connected since the page will sometimes request it before firebase can connect
      if (window.vue_instance.$data.watchdog.watchdogDbConnected === true && typeof this.objectAttributeUid === 'string') {
        window.G_watchdog_data.initObjectAttributeMetaDataListener(this.objectAttributeUid);
        this.$emit('event-add-object-attribute-uid-to-active-listeners', this.objectAttributeUid);
        this.objectAttributeMetaData = window.G_watchdog_data.IV_object_attributes_meta_data;
        this.isInitiailized = true;
      } else {
        setTimeout(this.startListener, 200);
      }
    }
  },
  computed: {
    C_calculatedNameLabel() {
      // human readable name
      if (this.isInitiailized === true && 
          this.objectAttributeUid !== null && this.objectAttributeUid !== undefined && 
          this.objectAttributeUid in this.objectAttributeMetaData && 
          this.objectAttributeMetaData[this.objectAttributeUid] &&
          'name' in this.objectAttributeMetaData[this.objectAttributeUid]) {
        this.DV_isLoading = false;
        return this.objectAttributeMetaData[this.objectAttributeUid]['name'];
      // uid in case we can't look up human readable name
      } else if (this.objectAttributeUid !== null && this.objectAttributeUid !== undefined &&
                (this.objectAttributeUid in this.objectAttributeMetaData === false || 
                !this.objectAttributeMetaData[this.objectAttributeUid] ||
                'name' in this.objectAttributeMetaData[this.objectAttributeUid] === false )
        ) {
        this.DV_isLoading = true;
        return `Loading: ${this.objectAttributeUid}`
      } else {
        this.DV_isLoading = true;
        return "Loading..."
      }
    }
  },
  watch: {
    objectAttributeMetaData() {
      if (this.isNameNeeded === undefined || this.isNameNeeded === false) {
        return;
      }
      if (this.objectAttributeUid !== null && 
          this.objectAttributeUid in this.objectAttributeMetaData && 
          this.objectAttributeMetaData[this.objectAttributeUid] &&
          'name' in this.objectAttributeMetaData[this.objectAttributeUid]) {
        var name = this.objectAttributeMetaData[this.objectAttributeUid]['name'];
        this.$emit("event-object-attribute-name-changed", name);
      }
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Labels/c13ObjectAttributeNameLabel.vue